import React from 'react';
import { useSiteRefreshTheme } from '../../pages/SiteRefreshPreview/SiteRefreshThemeContext';

const PreviewThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme, isDark } = useSiteRefreshTheme();

  return (
    <button
      type="button"
      className={`site-refresh__theme-toggle ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
      title={isDark ? 'Modo claro' : 'Modo escuro'}
    >
      <span className="site-refresh__theme-toggle-icon" aria-hidden="true">
        {isDark ? '☀' : '☾'}
      </span>
      <span className="site-refresh__theme-toggle-label">
        {isDark ? 'Claro' : 'Escuro'}
      </span>
    </button>
  );
};

export default PreviewThemeToggle;
